<template>
    <div style="width:100%;height:100%">
        <buttonlist  ref="SetBtn" @help="help"></buttonlist>
        <el-card class="box-card">
            <el-row style="display: flex;background: white;">
                <el-button type="primary" size="mini" @click="download">{{$t('getapi[6506]')}}</el-button>
                <el-button type="primary" size="mini" @click="showitems">{{ $t('getapi[438]') }}</el-button>
                <el-button type="primary" size="mini" @click="remove">{{ $t('getapi[4411]') }}</el-button>
                
                <el-col :span="5" style="text-align: left">
                    <el-upload
                            class="upload-demo"
                            ref="upload"
                            :action="uploadurl"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :on-change="handleChange"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :file-list="fileList"
                            :limit="1"
                            style="margin-left: 10px"
                    >
                    <el-button slot="trigger" size="mini" type="primary">{{ $t('getapi[4410]') }}</el-button>
                    </el-upload>
                </el-col>
                <el-col :span="18" style="text-align: right">
                    <span style="padding:0 20px;">{{ $t('getapi[506]') }}</span>
                    <el-select filterable v-model="editPlan" :placeholder="$t('getapi[6085]')" size="mini" style="margin-righ:20px">
                        <el-option v-for="item in editPlanList" :key="item.value" :label="item.label"
                                   :value="item.value"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="2" style="text-align: right">
                    <el-button type="primary" size="mini" @click="update">{{ $t('getapi[507]') }}</el-button>
                    <!--<el-button type="primary" size="mini">关闭</el-button>-->
                </el-col>
            </el-row>
        </el-card>
        <el-card class="box-card">
            <!-- <div slot="header" class="clearfix"><span>计划相关设置</span></div> -->
            <vxe-table
                    :data="dataSet"
                    v-loading="loading"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    stripe
                    size="mini"
                    resizable
                    :height="tableHeight"
                    header-row-class-name="headerclass"
                    tab-click="selectInfo(0)"
                    @checkbox-change="handleSelectionChange"
                    style="width: 100%; margin-top:0px"
                    ref="singleTable"
            >
                <vxe-table-column type="checkbox" align="center" width="30"></vxe-table-column>
                <!-- <vxe-table-column show-overflow-tooltip field="errormsg" :title="$t('getapi[504]')" width="80"></vxe-table-column> -->
                <vxe-table-column show-overflow-tooltip field="vender_code" :title="$t('getapi[1287]')"  width="80"></vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'with_days' ? 'check' : ''"
                                 field="with_days" :title="$t('getapi[8208]')" align="right"  width="80">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.with_days"
                                  v-if="editPlan == 'with_days'" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'with_days'">{{ scope.row.with_days }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'contact_person' ? 'check' : ''"
                                 field="contact_person" :title="$t('getapi[1241]')" width="80">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.contact_person"
                                  v-if="editPlan == 'contact_person'"></el-input>
                        <span v-if="editPlan != 'contact_person'">{{ scope.row.contact_person }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'phone_number' ? 'check' : ''"
                                 field="phone_number" :title="$t('getapi[1202]')" width="100">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.phone_number"
                                  v-if="editPlan == 'phone_number'"></el-input>
                        <span v-if="editPlan != 'phone_number'">{{ scope.row.phone_number }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'mail_address' ? 'check' : ''"
                                 field="mail_address" :title="$t('getapi[1207]')" width="100">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.mail_address"
                                  v-if="editPlan == 'mail_address'"></el-input>
                        <span v-if="editPlan != 'mail_address'">{{ scope.row.mail_address }}</span>
                    </template>
                </vxe-table-column>

                <vxe-table-column :class-name="editPlan == 'bank_account_name' ? 'check' : ''"
                                 field="bank_account_name" :title="$t('getapi[1219]')" width="100">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.bank_account_name"
                                  v-if="editPlan == 'bank_account_name'"></el-input>
                        <span v-if="editPlan != 'bank_account_name'">{{ scope.row.bank_account_name }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'bank_account_number' ? 'check' : ''"
                                 field="bank_account_number" :title="$t('getapi[1220]')" width="100">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.bank_account_number"
                                  v-if="editPlan == 'bank_account_number'"></el-input>
                        <span v-if="editPlan != 'bank_account_number'">{{ scope.row.bank_account_number }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'electronics' ? 'check' : ''"
                                 field="electronics" :title="$t('getapi[6277]')" width="100">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.electronics"
                                  v-if="editPlan == 'electronics'"></el-input>
                        <span v-if="editPlan != 'electronics'">{{ scope.row.electronics }}</span>
                    </template>
                </vxe-table-column>

                <vxe-table-column :class-name="editPlan == 'cloud' ? 'check' : ''"
                                 field="cloud" :title="$t('getapi[6278]')" width="100">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.cloud"
                                  v-if="editPlan == 'cloud'"></el-input>
                        <span v-if="editPlan != 'cloud'">{{ scope.row.cloud }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'large_amount' ? 'check' : ''"
                                 field="large_amount" :title="$t('getapi[6279]')" width="100">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.large_amount"
                                  v-if="editPlan == 'large_amount'"></el-input>
                        <span v-if="editPlan != 'large_amount'">{{ scope.row.large_amount }}</span>
                    </template>
                </vxe-table-column>

                <vxe-table-column :class-name="editPlan == 'ele_bank' ? 'check' : ''"
                                 field="ele_bank" :title="$t('getapi[6280]')" width="100">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.ele_bank"
                                  v-if="editPlan == 'ele_bank'"></el-input>
                        <span v-if="editPlan != 'ele_bank'">{{ scope.row.ele_bank }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'tax_number' ? 'check' : ''"
                                 field="tax_number" :title="$t('getapi[1224]')" width="100">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.tax_number"
                                  v-if="editPlan == 'tax_number'"></el-input>
                        <span v-if="editPlan != 'tax_number'">{{ scope.row.tax_number }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'sort_name' ? 'check' : ''"
                                 field="sort_name" :title="$t('getapi[8059]')" width="150">
                    <template scope="scope">
                        <el-select filterable class-name="check" v-model="scope.row.sort_name"
                                   v-if="editPlan == 'sort_name'">
                            <el-option v-for="item in vendertypelist" 
                                :key="item.sort_Name" :title="item.sort_Name" :value="item.sort_Name" size="mini"></el-option>
                        </el-select>
                        <span v-if="editPlan != 'sort_name'">{{ scope.row.sort_name }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'OLBank_Account_Number' ? 'check' : ''"
                                  field="tax_number" :title="$t('getapi[12854]')" width="100">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.OLBank_Account_Number"
                                  v-if="editPlan == 'OLBank_Account_Number'"></el-input>
                        <span v-if="editPlan != 'OLBank_Account_Number'">{{ scope.row.OLBank_Account_Number }}</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column :class-name="editPlan == 'swift_code' ? 'check' : ''"
                                  field="swift_code" :title="$t('getapi[8322]')" width="100">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.swift_code"
                                  v-if="editPlan == 'swift_code'"></el-input>
                        <span v-if="editPlan != 'swift_code'">{{ scope.row.swift_code }}</span>
                    </template>
                </vxe-table-column>
            </vxe-table>
        </el-card>
        <selector :isVisible="itevisible" :isBatch=true :selectType="0" :isSplitPage=true
                  :postUrl="'/GetPopupVenderInfo'" @callback="getitembom" ref="input"></selector>
    </div>
</template>
<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import CommonHeader from '@/components/CommonHeader';

    export default {
        name: 'venderbatchupdate',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight-180
            }
        },
        data() {
            return {
                itevisible: false,
                dataSet: [],
                dataChecked: [], // 选中的ID集合
                loading: false, // 主表加载状态
                uploadurl: '',
                fileList: [],
                editPlan: '0',
                editPlanList: [
                    {
                        value: '0',
                        label: this.$t('getapi[852]')//'未选择'
                    },
                    {
                        value: 'with_days',
                        label: this.$t('getapi[8208]')//'下单合并天数'
                    },
                    {
                        value: 'contact_person',
                        label: this.$t('getapi[1241]')//'联系人姓名'
                    },
                    {
                        value: 'phone_number',
                        label: this.$t('getapi[1202]')//'联系电话'
                    },
                    {
                        value: 'mail_address',
                        label: this.$t('getapi[1207]')//'电子邮件'
                    },
                    {
                        value: 'bank_account_name',
                        label: this.$t('getapi[1219]')//'开户银行'
                    },
                    {
                        value: 'bank_account_number',
                        label: this.$t('getapi[1220]')//'银行账号'
                    },
                    {
                        value: 'electronics',
                        label: this.$t('getapi[6277]')//'电子承兑账号'
                    },
                    {
                        value: 'cloud',
                        label: this.$t('getapi[6278]')//'云信账号'
                    },
                    {
                        value: 'large_amount',
                        label: this.$t('getapi[6279]')//'电子承兑大额行号'
                    },
                    {
                        value: 'ele_bank',
                        label: this.$t('getapi[6280]')//'电子承兑开户行'
                    },
                    {
                        value: 'tax_number',
                        label: this.$t('getapi[1224]')//'税号'
                    },
                    {
                        value: 'sort_name',
                        label: this.$t('getapi[1198]')//'供应商类型'
                    },
                    {
                        value: 'OLBank_Account_Number',
                        label: this.$t('getapi[12854]')//'网银开户行号'
                    },
                    {
                        value: 'swift_code',
                        label: this.$t('getapi[8322]')//'swift_code'
                    }
                ],
                              
                mp_flag: [
                    {
                        value: '采购',
                        label: this.$t('getapi[235]')//'采购'
                    },
                    {
                        value: '自制',
                        label: this.$t('getapi[242]')//'自制'
                    }
                ],
                vendertypelist:[],
                scrollTop:0,
            };
        },
        beforeMount() {
            let that = this;
            that.fileList = [];
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            let LangType = that.$processdata.getLang();
            that.uploadurl = Common.Url + '/VenderImportUpFile?LangType='+LangType+'&token=' + token;
        },
        mounted: function () {
            let that = this;
            that.authority();
            this.getselect();
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6539]"),this.$t("getapi[17]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                // //只读权
                that.$refs.SetBtn.SetButtonEnable('');
            },
            //获取下拉数据
            getselect() {
                let that = this;
                let parm = {};
                that.$http.urlpost('VenderTypeSource', parm, function (res) {
                    if (res.Success == 1) {
                        that.vendertypelist = res.DataContent;
                    }
                });
            },
            // 新物料打开
            showitems() {
                this.itevisible = true;
                this.$refs.input.clearInput(this.itevisible);
            },
            download(){
                let that = this;
                let token = JSON.parse(that.userData).token;
                let LangType = that.$processdata.getLang();
                $.ajax({
                    url: Common.Url + '/UpdateVenderTemplate?LangType='+LangType+'&token=' + token,
                    type: 'post',
                    data: '',
                    contentType: 'application/json',
                    success: function (res) {
                        if (res.Success == 1) {
                            let hrefurl = Common.Url + res.DataContent.URL;
                            window.open(hrefurl);
                        } else {
                            that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                        }
                    }
                });
            },
            getitembom(data) {
                let that = this;
                console.log(data)
                data = data.filter(item => {
                    return that.dataSet.every(item2 => {
                        return item.vender_code != item2.vender_code;
                    });
                });
                for (let i = 0; i < data.length; i++) {
                    that.dataSet = [...that.dataSet, {
                        vender_code: data[i].vender_code,
                        with_days: data[i].with_days,
                        contact_person: data[i].contact_person,
                        phone_number: data[i].phone_number,
                        mail_address: data[i].mail_address,
                        bank_account_name: data[i].bank_account_name,
                        bank_account_number: data[i].bank_account_number,
                        electronics: data[i].electronics,
                        cloud: data[i].cloud,
                        large_amount: data[i].large_amount,
                        ele_bank: data[i].ele_bank,
                        tax_number: data[i].tax_number,
                        sort_name: data[i].sort_name,
                        OLBank_Account_Number:data[i].OLBank_Account_Number,
                        swift_code:data[i].swift_aba
                    }];
                }
                        
            },
            handleSelectionChange({records}) {
                let that = this;
                for (let i = 0; i < records.length; i++) {
                    that.dataChecked.push(records[i].vender_code);
                }
            },
            remove() {
                let that = this;
                let arr = that.dataSet.filter(item => {
                    return that.dataChecked.every(item2 => {
                        return item.vender_code != item2;
                    });
                });
                that.dataSet = arr;
            },
            handleChange(file, fileList) {
                let that = this;
                /*if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(file.response.Msg);
                    } else {
                        that.dataSet = file.response.DataContent;
                    }
                }*/
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                that.fileList=[];
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    
                    let data = res.DataContent
                    for (let i = 0; i < data.length; i++) {
                        that.dataSet = [...that.dataSet, {
                            errormsg: data[i].errormsg,
                            vender_code: data[i].vender_code,
                            with_days: data[i].with_days,
                            contact_person: data[i].contact_person,
                            phone_number: data[i].phone_number,
                            mail_address: data[i].mail_address,
                            bank_account_name: data[i].bank_account_name,
                            bank_account_number: data[i].bank_account_number,
                            electronics: data[i].electronics,
                            cloud: data[i].cloud,
                            large_amount: data[i].large_amount,
                            ele_bank: data[i].ele_bank,
                            tax_number: data[i].tax_number,
                            sort_name: data[i].sort_name,
                            OLBank_Account_Number:data[i].OLBank_Account_Number,
                            swift_code:data[i].swift_code,
                        }]
                    }
                    
                }
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            },
            update() {
                let that = this;
                if (that.editPlan == '0') {
                    that.$message.warning(that.$t('getapi[8625]'));//'请选择更新字段'
                    return
                }
                let parm = {
                    PageIndex: 0,
                    PageSize: 0,
                    Param: that.dataSet,
                    id: '',
                    name: that.editPlan
                };
                that.$http.urlpost('/UpdateVenderInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            }
        }
    };
</script>

<style scoped lang="less">
    .c-search-table {
        width: 100%;
        height: calc(~'100% - 10px'); /*这里我用了计算属性*/
    }

    .beauty-Scroll {
        .el-scrollbar {
            height: 100%; /*此处一定要设置高度，不然内层的计算属性不生效*/
        }
        .el-scrollbar__wrap {
            width: calc(~'100% + 17px'); /*将垂直滚动条挤到可视区域之外*/
            height: calc(~'100% + 17px'); /*将水平滚动条挤到可视区域之外*/
        }
    }
    

    input {
        width: 100%;
        height: 35px;
        border-radius: 8px;
        border: 1px solid #dcdfe6;
        padding-left: 2px;
        padding-right: 2px;
    }

    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
        }
    }

    .alignment-left {
        text-align: left;
    }

    .alignment-right {
        text-align: right;
    }

    .el-pagination {
        white-space: inherit;
    }
    
</style>
